<app-payment-panel-stripe-generic
  [type]="paymentMethodHandles.Stripe"
  [payButtonText]="'payment.pay-with-credit-card' | translate"
></app-payment-panel-stripe-generic>
